import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from './services/auth.service';
import { AuthReturnUrlService } from './services/auth-return-url.service';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private returnUrl: AuthReturnUrlService,
    private router: Router,
  ) {}

  canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const isAuthenticated = this.authService.isAuthenticated();
    const token = this.authService.getToken();
    if (isAuthenticated) {
      if (token){
        const decodedToken = this.authService.decodeToken(token);
        if (decodedToken && decodedToken.role === 'Admin') {
          return true;
        }
      }
      return this.router.parseUrl('/dashboard');
    }
    return this.returnUrl.loginUrlTree(state.url);
  }
}
